import { useState } from "react";
import classnames from "classnames/bind";
import dynamic from "next/dynamic";
import styles from "./ZoomableImage.module.scss";
import { imageProfileGenerator } from "../../../../utils/image/imageProfileGenerator";
import { GalleryImageObject } from "../../utils";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

const ImageElement = dynamic(
  () =>
    import(
      /* webpackChunkName: "GalleryImageElement" */
      "./ImageElement/ImageElement.tsx"
    ).then((mod) => mod.ImageElement),
  { ssr: false },
);

const cx = classnames.bind(styles);

type ZoomableImageProps = {
  mediaItem: GalleryImageObject;
  dataTestId: string;
  className?: string;
  loading?: "eager" | "lazy";
  isSelected: boolean;
  hasSuperZoom?: boolean;
  carouselGalleryInpTest?: boolean;
  index: number;
};

export function ZoomableImage({
  mediaItem,
  dataTestId,
  className,
  loading,
  isSelected,
  hasSuperZoom = true,
  carouselGalleryInpTest = false,
  index,
}: ZoomableImageProps) {
  const [isZoomed, setIsZoomed] = useState(false);
  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  return hasSuperZoom ? (
    <ImageElement
      image={mediaItem}
      key={mediaItem.imageUrl}
      isSelectedIndex={isSelected}
      carouselGalleryInpTest={carouselGalleryInpTest}
    />
  ) : (
    <div
      className={cx(styles.container, { ["isZoomed"]: isZoomed })}
      onClick={toggleZoom}
    >
      <img
        src={formatAmplienceImageURL(mediaItem.imageUrl)}
        alt={`Product image ${index + 1}`}
        data-testid={dataTestId}
        className={cx(className, "image")}
        sizes="100vw"
        srcSet={imageProfileGenerator(mediaItem.imageUrl)}
        loading={loading}
      />
    </div>
  );
}
